import React from 'react';
import '../../../scss/app.scss';
import "react-toggle/style.css";
import { Card, CardContent } from '@mui/material';
import { convertPhoneNumber } from '../../Shared/Functions';

export function BillingInformation({ account }) {

    let paneStyle = {
        width: "100%",
        marginTop: "20px"
    };

    return (
        <Card style={paneStyle}>
            <CardContent style={{padding:"15px 0px 0px 15px"}}>
                <div>
                    <div>
                        <div><strong>Utility Provider</strong></div>
                        <p style={{ lineHeight: "1.5" }}>
                            {account.districtInfo?.name} <br />
                            {convertPhoneNumber(account.districtInfo?.phoneNumber)} <br />
                            {account.districtInfo?.street} <br />
                            {account.districtInfo?.city + ", " + account.districtInfo?.state + " " + account.districtInfo?.zip}
                        </p>
                    </div>
                </div>
            </CardContent>
        </Card>
        )
}
